module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":{"search_tag":"タグ名で検索","add_tag":"タグを追加","add_specific_tag":"「{t}」を追加"},"button":{"cancel":"キャンセル","ok":"OK"}},"en":{"label":{"search_tag":"Search Tag","add_tag":"Add Tag","add_specific_tag":"Add \\"{t}\\""},"button":{"cancel":"Cancel","ok":"OK"}}}')
  delete Component.options._Ctor
}
